import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconOpenAi12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconOpenAi12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M10.34 5.093a2.46 2.46 0 0 0-.216-2.046 2.57 2.57 0 0 0-2.75-1.21A2.54 2.54 0 0 0 5.468 1a2.55 2.55 0 0 0-2.436 1.744 2.52 2.52 0 0 0-1.688 1.209 2.49 2.49 0 0 0 .314 2.954c-.23.681-.15 1.427.217 2.047a2.57 2.57 0 0 0 2.75 1.208A2.54 2.54 0 0 0 6.531 11a2.55 2.55 0 0 0 2.436-1.746 2.52 2.52 0 0 0 1.689-1.208 2.49 2.49 0 0 0-.315-2.954zm-3.809 5.254c-.444 0-.874-.153-1.216-.434l.06-.034 2.018-1.15a.32.32 0 0 0 .166-.283V5.639l.853.486a.03.03 0 0 1 .017.023v2.324c-.002 1.034-.85 1.872-1.898 1.875m-4.08-1.72a1.85 1.85 0 0 1-.227-1.256l.06.035 2.018 1.15c.103.06.23.06.332 0l2.464-1.403v.972q0 .016-.013.026l-2.04 1.162a1.915 1.915 0 0 1-2.594-.686M1.92 4.28c.221-.38.571-.67.988-.821v2.368a.32.32 0 0 0 .165.284l2.463 1.403L4.684 8a.03.03 0 0 1-.03.003L2.615 6.84a1.863 1.863 0 0 1-.695-2.56m7.007 1.61L6.463 4.484 7.316 4a.03.03 0 0 1 .03-.003l2.04 1.163a1.86 1.86 0 0 1 .694 2.56c-.222.38-.571.67-.988.821V6.172a.32.32 0 0 0-.165-.283m.849-1.261-.06-.036-2.018-1.15a.33.33 0 0 0-.332 0L4.903 4.847v-.972q0-.016.012-.026l2.04-1.161a1.913 1.913 0 0 1 2.594.687c.221.38.301.823.226 1.254M4.439 6.36l-.853-.486a.03.03 0 0 1-.017-.023V3.527c.001-1.035.852-1.874 1.901-1.873.444 0 .873.154 1.214.434l-.06.033-2.018 1.15a.32.32 0 0 0-.166.283zm.463-.986L6 4.75l1.097.625v1.25L6 7.25l-1.098-.625z"
            />
        </svg>
    );
}
export default memo(IconOpenAi12);
